const FooterTitle = ({text}) => {
    return ( 
        <h3 className="font-extrabold text-gray-300 text-lg">{text}</h3>
    );
}

export default FooterTitle;